module.exports = __webpack_public_path__ + "img/img-zf-07.png";